<script lang="ts" setup>
import { useDefaultFieldValues } from '@/components/form-builder/field-settings/useDefaultFieldValues'

interface Props {
  field: {
    isMultiline: boolean
    defaultValue?: string | null
    uniqueKey: () => string
  }
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (
    e: 'modify-field',
    payload: {
      propertyKey: string
      fieldValue: boolean | string | null
      key: string
    },
  ): void
}>()

function toggleMultiline() {
  emit('modify-field', {
    propertyKey: 'isMultiline',
    fieldValue: !props.field.isMultiline,
    key: props.field.uniqueKey(),
  })
}

const { showDefaultValue, toggleDefaultValue } = useDefaultFieldValues(props.field)
</script>

<template>
  <vs-wrapper space="small">
    <v-checkbox
      :input-value="field.isMultiline"
      label="Multi line text input"
      mandatory
      @change="toggleMultiline"
    />

    <v-checkbox
      :input-value="showDefaultValue"
      label="Default Value"
      @change="toggleDefaultValue"
    />

    <div v-if="showDefaultValue">
      <vs-text-input v-model="field.defaultValue" label="" placeholder="Enter default value" />
    </div>
  </vs-wrapper>
</template>
